import Layout from '@layouts/Layout';
import ContactUs from '@screens/Company/ContactUs';

import React, { memo } from 'react';

const title = 'Contact us';
const description = 'How can we help you? Send us a message and we will do all our best to get back to you as soon as possible. Traqq Team is here to help 24/7!';

const ContactPage = () => (
    <Layout
        title={ title }
        description={ description }
    >
        <ContactUs />
    </Layout>
);

export default memo(ContactPage);
